import { ContentList } from "~/components/content-list/ContentList";
import { TThreadTimelineEntry } from "~/components/thread-timeline-entry/util";
import { QuoteParentThreadTimeline } from "~/components/QuoteParentThreadTimeline";
import { ThreadTimelineEntry } from "~/components/thread-timeline-entry/ThreadTimelineEntry";
import { Observable, Subject } from "rxjs";
import { ParentThreadTimelineContextProvider, ThreadTimelineContext } from "~/components/thread-timeline-entry/context";
import { ParentComponent } from "~/utils/type-helpers";

export const ParentThreadTimeline: ParentComponent<{
  parentThreadId: string;
  parentMessageId: string;
  onArrowDownOverflow: () => void;
  loadMoreMessagesButtonFocusEvents: Observable<void>;
  collapseMessageEvents: Subject<"expand" | "collapse" | string>;
}> = (props) => {
  return (
    <ContentList<TThreadTimelineEntry>
      // onArrowUpOverflow={onArrowUpOverflow}
      onArrowDownOverflow={props.onArrowDownOverflow}
      focusOnMouseOver={false}
    >
      <ThreadTimelineContext.Provider value={{ collapseMessageEvents: props.collapseMessageEvents }}>
        <ParentThreadTimelineContextProvider>
          <QuoteParentThreadTimeline
            isFirstBranch
            parentThreadId={props.parentThreadId}
            parentMessageId={props.parentMessageId}
            branchCreatedAt="now"
            loadMoreMessagesButtonFocusEvents={props.loadMoreMessagesButtonFocusEvents}
          >
            {({ id, relativeIndex }) => {
              return <ThreadTimelineEntry key={id} timelineId={id} relativeOrder={relativeIndex} />;
            }}
          </QuoteParentThreadTimeline>
        </ParentThreadTimelineContextProvider>
      </ThreadTimelineContext.Provider>
    </ContentList>
  );
};
